__turbopack_context__.v({
  "copy-wrapper-ref": "K0ECaq_copy-wrapper-ref",
  "copyWrapper": "K0ECaq_copyWrapper",
  "desktopProgress": "K0ECaq_desktopProgress",
  "mobileProgress": "K0ECaq_mobileProgress",
  "progressBar": "K0ECaq_progressBar",
  "sectionWrapper": "K0ECaq_sectionWrapper",
  "tag": "K0ECaq_tag",
  "tag-text": "K0ECaq_tag-text",
});
